import { Check } from 'lucide-react';
import { type ComponentProps } from 'react';

import { cn } from '@apps/web/lib/utils';

export function SelectionCheckboxIndicator({
    checked,
    className,
    ...props
}: ComponentProps<'span'> & { readonly checked: boolean }) {
    return (
        <span
            {...props}
            aria-hidden={true}
            className={cn(
                'pointer-events-none flex size-[18px] shrink-0 items-center justify-center rounded-[5px] border',
                checked
                    ? 'border-foreground bg-foreground text-background'
                    : 'border-foreground/50 bg-transparent',
                className,
            )}
        >
            {checked ? <Check className="size-3" /> : null}
        </span>
    );
}

export function SelectionCheckbox({
    checked,
    onCheckedChange,
    className,
    ...props
}: Omit<ComponentProps<'button'>, 'onChange' | 'onClick' | 'children'> & {
    readonly checked: boolean;
    readonly onCheckedChange: (checked: boolean) => void;
}) {
    return (
        <button
            {...props}
            type="button"
            role="checkbox"
            aria-checked={checked}
            className={cn(
                'flex size-7 shrink-0 items-center justify-center rounded-md focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            onClick={(event) => {
                event.stopPropagation();
                onCheckedChange(!checked);
            }}
        >
            <SelectionCheckboxIndicator checked={checked} />
        </button>
    );
}
